<script setup lang="ts">
import { CULTURE, setLocationToEnquiryPage } from '@/composables/helpers'
import t from '@/i18n/translations'
import { EnquiryType } from '@/store/enquiry.store'

const props = defineProps<{
  cid: number
}>()

const emit = defineEmits<{
  track: []
}>()
</script>

<template>
  <div class="actions relative text-right">
    <button
      @click="emit('track'), setLocationToEnquiryPage(EnquiryType.Direct, props.cid)"
      class="myEnquiryButton z- w-full whitespace-nowrap rounded border border-primary px-2 py-1"
    >
      {{ t(`${CULTURE}.acco.requestNow`) }}
    </button>
  </div>
</template>
